import { Injectable } from '@angular/core';

/**
 * Holds the guest JWT in memory for the current tab only. Deliberately dependency-free (no HttpClient)
 * so the AuthInterceptor can read it without creating a DI cycle. Not persisted — a guest re-redeems
 * their emailed code if they reload/return, which is the intended security posture.
 */
@Injectable({ providedIn: 'root' })
export class GuestTokenStore {
  private _token: string | null = null;

  get token(): string | null {
    return this._token;
  }

  set(token: string | null): void {
    this._token = token;
  }
}
